import React, { useCallback, useEffect, useState } from 'react';
import './../Form.scss';
import './ConfiguracoesForm.scss';
import { useHistory, useParams } from 'react-router';
import service from '../../../services/configuracoes';
import { useForm } from "react-hook-form";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan, faRedoAlt, faSave, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { hasText } from '../../../utils/utils';
import { formatCurrency } from '../../../utils/Money';
import { actions as actionsSite } from './../../../redux/actions/site';
import { useDispatch } from 'react-redux';
const ConfiguracoesForm = props => {

    const history = useHistory();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);
    
    const [configuracao, setConfiguracao] = useState({});

    const { register, handleSubmit, setValue } = useForm();

    const onSubmit = data => {
        save(data);
    };

    const carregarConfiguracao = useCallback(async () => {
        const configuracaoInicial = await service.getUnique();
        setConfiguracao(configuracaoInicial.obj || {percentualJuros:10, percentualMulta:15});
        setLoading(false);
    }, []);


    useEffect(() => {
        carregarConfiguracao();
    }, [carregarConfiguracao ]);

    const save = async (data) => {
        dispatch(actionsSite.setLoadingMsg("Enviando dados..."));
        const res = await service.upsert(data, configuracao._id);
        dispatch(actionsSite.setLoadingMsg(res.msg));
        setTimeout(() => {
            dispatch(actionsSite.setLoadingMsg(""));
            if (!res.erro) {
                history.push('/painel/home');
            }
        }, 3000);
        
    }

    const changeValueMoney = (e, campo) => {
        const value = e.target.value;
        const newValue = formatCurrency(value);
        setValue(campo, newValue);
        document.querySelector("#" + campo).classList.add('hasText');
    }

    return (
        <>
            {!loading &&
        <form onSubmit={handleSubmit(onSubmit)} className="formModule branco ConfiguracoesForm">
            <div className="acoes">
                <button type="submit" className="salvar"><FontAwesomeIcon icon={faSave} /> {'Editar'}</button>
                <button type="button" className="cancelar" onClick={() => history.push('/painel/home')}><FontAwesomeIcon icon={faBan} /> Cancelar</button>
            </div>
            <div className="break"></div>

            <div className="field">
            <input className={configuracao.percentualMulta ? 'hasText' : ''} 
                    name="percentualMulta" id="percentualMulta" onKeyUp={(e) => hasText(e)} 
                    onChange={(e) => { changeValueMoney(e, 'percentualMulta') }}
                    ref={register({ required: true })}
                    defaultValue={formatCurrency(configuracao.percentualMulta)} 
                    type="text" />
                <label htmlFor="nome">Percentual Multa</label>
            </div>
            <div className="field">
                <input className={configuracao.percentualJuros ? 'hasText' : ''} 
                    name="percentualJuros" id="percentualJuros" onKeyUp={(e) => hasText(e)} 
                    onChange={(e) => { changeValueMoney(e, 'percentualJuros') }}
                    ref={register({ required: true })}
                    defaultValue={formatCurrency(configuracao.percentualJuros)} 
                    type="text" />
                <label htmlFor="apelido">Percentual Juros</label>
            </div>
           

           
            <div className="break"></div>
            <div className="acoes">
                <button type="submit" className="salvar"><FontAwesomeIcon icon={faSave} /> {'Editar'}</button>
                <button type="button" className="cancelar" onClick={() => history.push('/painel/home')}><FontAwesomeIcon icon={faBan} /> Cancelar</button>
            </div>
        </form>}
        {loading && "Carregando..."}
        </>
    )
}

export default ConfiguracoesForm;